/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsFabricColorListItem
 */
export interface DigitizingserviceMelcoDigitizingModelsFabricColorListItem {
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsFabricColorListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsFabricColorListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsFabricColorListItem
     */
    color_hex?: string | null;
}

export function DigitizingserviceMelcoDigitizingModelsFabricColorListItemFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsFabricColorListItem {
    return DigitizingserviceMelcoDigitizingModelsFabricColorListItemFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsFabricColorListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsFabricColorListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'color_hex': !exists(json, 'color_hex') ? undefined : json['color_hex'],
    };
}

export function DigitizingserviceMelcoDigitizingModelsFabricColorListItemToJSON(value?: DigitizingserviceMelcoDigitizingModelsFabricColorListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'color_hex': value.color_hex,
    };
}


